// extracted by css-extract-rspack-plugin
export default {"Box":"get-sub-issues-block-module__Box___TAvZyl","Box_1":"get-sub-issues-block-module__Box_1__icZZH6Z"};